import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2, ShieldCheck } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const VerifyCertPage = () => {
  const [params] = useSearchParams();
  const code = params.get('code') || '';
  const [state, setState] = useState({ loading: true, valid: false, data: null, reason: '' });

  useEffect(() => {
    if (!code) {
      setState({ loading: false, valid: false, reason: 'No code provided', data: null });
      return;
    }
    axios.get(`${API_URL}/api/badge/verify?code=${encodeURIComponent(code)}`)
      .then((r) => setState({ loading: false, valid: !!r.data?.valid, data: r.data, reason: r.data?.reason || '' }))
      .catch(() => setState({ loading: false, valid: false, reason: 'Network error', data: null }));
  }, [code]);

  if (state.loading) {
    return (
      <div className="min-h-screen bg-[#fdfdfc] flex items-center justify-center p-6">
        <Loader2 className="w-10 h-10 text-[#2565eb] animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#fdfdfc] flex items-center justify-center p-6">
      <div className="max-w-md w-full" data-testid="verify-cert-page">
        {state.valid ? (
          <div className="card-olympiad p-8 text-center border-2 border-green-400 bg-green-50">
            <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="w-12 h-12 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-green-800 mb-2" style={{ fontFamily: 'Fredoka, sans-serif' }}>
              ✓ Verified Badge
            </h1>
            <p className="text-3xl font-bold text-[#0f172a] mt-4" data-testid="verify-name">{state.data?.child_name}</p>
            <p className="text-sm text-[#475569] mt-2">Participated in</p>
            <p className="text-lg font-semibold text-[#0f172a]">{state.data?.event_name}</p>
            <p className="text-sm text-[#475569] mt-1" data-testid="verify-date">
              {state.data?.event_date && new Date(state.data.event_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
            {state.data?.rank && state.data.rank <= 3 && (
              <p className="mt-3 text-amber-600 font-bold">Rank #{state.data.rank}</p>
            )}
            <div className="mt-6 pt-4 border-t border-green-200 flex items-center justify-center gap-2 text-xs text-green-700">
              <ShieldCheck className="w-4 h-4" /> Issued by Brain Gym Jr. • Code: {code}
            </div>
          </div>
        ) : (
          <div className="card-olympiad p-8 text-center border-2 border-red-400 bg-red-50">
            <div className="w-20 h-20 rounded-full bg-red-500 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-12 h-12 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-red-800 mb-2" style={{ fontFamily: 'Fredoka, sans-serif' }}>
              ✗ Invalid Badge
            </h1>
            <p className="text-sm text-red-700">{state.reason || 'This badge could not be verified.'}</p>
            <p className="text-xs text-red-600 mt-3 font-mono">{code}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyCertPage;
